const formatRecipientList = (participantsList = []) => {
    if(!participantsList) return '';

    let recipientShown = '';
    let displayNameLimit = 0;

    if (participantsList.length === 1){
        return participantsList[0].displayName;
    }
    displayNameLimit = ( participantsList.length > 1) ? 1 : participantsList.length -1  
    participantsList.slice(0, displayNameLimit).forEach((item, index) => {
        if (!item.displayName) return;
        recipientShown += item.displayName.replace(/,/g, '');
        recipientShown += (index === (displayNameLimit -1 )) ? '': ', '
    });
    const lastElement = (participantsList[participantsList.length -1 ].displayName) ?
        participantsList[participantsList.length -1 ].displayName.replace(/,/g, '') :
        null;

    return (participantsList.length > 1) ?
        `${recipientShown } and ${participantsList.length - displayNameLimit} others.`:
        `${recipientShown}` + ((lastElement) ? ` and ${lastElement}` : '');
}

export default formatRecipientList;